import React, { useState, useEffect, useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase-config";

function Index() {
  const [allPatientsData, setAllPatientsData] = useState([]);
  const [caseData, setCaseData] = useState([]);
  const [slideData, setSlideData] = useState([]);
  const [allReports, setAllReports] = useState([]);


  const fetchData = async () => {
    const querySnapshot = await getDocs(collection(db, "Patients"));
    const cases = await getDocs(collection(db, "Cases"));
    const slides = await getDocs(collection(db, "Slides"));
    const reports = await getDocs(collection(db, "Reports"));

    const patientsData: any = [];
    const reportsData: any = [];
    const tempCase: any = [];
    const res: any = [];

    querySnapshot.forEach((doc) => {
      patientsData.push({
        ...doc.data()
      })
      console.log(doc.id, " => ", doc.data());
    });

    reports.forEach((doc) => {
      reportsData.push({
        ...doc.data()
      })
      console.log(doc.id, " => ", doc.data());
    });

    cases.forEach((case_) => {
      // const temp = case_.data()

      // if(temp.label === "PATHO"){
        tempCase.push({
          name: case_.id,
          ...case_.data(),
        });
      // }

    });

    slides.forEach((slide) => {
      res.push({
        name: slide.id,
        ...slide.data(),
      });

    });

    setAllReports(reportsData);
    setSlideData(res);
    setCaseData(tempCase);
    setAllPatientsData(patientsData)
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Layout title="" pageTitle="Home">
      <div>
          <div className="flex-4">
                    <a className="stat-card">
                        <div className="stat-name">Total Patients</div>
                        <div className="stat-value">{allPatientsData.length}</div>
                    </a>
                    <a className="stat-card">
                      <div className="stat-name">Total Cases</div>
                        <div className="stat-value">{caseData.length}</div>
                    </a>
                    <a className="stat-card">
                      <div className="stat-name">Total Slides</div>
                        <div className="stat-value">{slideData.length}</div>
                    </a>
                    <a className="stat-card">
                      <div className="stat-name">Total Reports</div>
                        <div className="stat-value">{allReports.length}</div>
                    </a>
                </div>
      </div>
    </Layout>
  )
}

export default Index